import { Routes } from "@angular/router";
import { TablePageComponent } from "./table-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const tablePageRoutes: Routes = [
  {
    path: 'records/:resourceType',
    component: TablePageComponent,
    canActivate: [authGuard]
  }
]
